import { Modal, ModalBody } from "reactstrap";
import { ModalButton, styles } from "../../pages/MyTracks/styles";
import { Box, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { TrackDeleteConfirmModalProps } from "./types";
import { APP_COLOR } from "../../theme";

export const TrackDeleteConfirmModal: React.FC<
  TrackDeleteConfirmModalProps
> = ({
  deleteConfirmModalOpen,
  closeDeleteConfirmModal,
  handleDeleteTrack,
  type,
}) => {
  return (
    <>
      <Modal
        isOpen={deleteConfirmModalOpen}
        toggle={closeDeleteConfirmModal}
        centered
        keyboard={false}
      >
        <ModalBody style={styles.postMessageModal}>
          <IconButton
            onClick={closeDeleteConfirmModal}
            style={styles.postMessageModalIcon}
          >
            <CloseIcon style={{ color: APP_COLOR }} />
          </IconButton>
          <Box>{`Are you sure you want to delete this ${
            type === "File" ? "file" : "version"
          }?`}</Box>
          <Box>
            <ModalButton
              sx={{ marginRight: 2 }}
              size="small"
              variant="contained"
              disableFocusRipple
              onClick={handleDeleteTrack}
            >
              Yes
            </ModalButton>
            <ModalButton
              size="small"
              variant="contained"
              disableFocusRipple
              onClick={closeDeleteConfirmModal}
            >
              No
            </ModalButton>
          </Box>
        </ModalBody>
      </Modal>
    </>
  );
};
